import React from "react";
import { motion } from "framer-motion";

const sectionVariants = {
	hidden: { opacity: 0, y: 50 },
	visible: {
		opacity: 1,
		y: 0,
		transition: { duration: 0.7, ease: "easeOut" },
	},
};

const SectionWrapper = ({ id, className = "", children }) => {
	return (
		<section id={id} className={`section ${className}`}>
			<motion.div
				variants={sectionVariants}
				initial="hidden"
				whileInView="visible"
				viewport={{ once: true, amount: 0.15 }}
			>
				{children}
			</motion.div>
		</section>
	);
};

export default SectionWrapper;
